import AxiosInterceptor from "../../AxiosInterceptorAlcohol";

// 대시보드 교육 상태별 건수 조회
export function getDashboardTraining() {
    return AxiosInterceptor({
        url: '/dashboard/training',
        method: 'get'
    })
}

// 대시보드 환자 타입별 건수 조회
export function getDashboardPatientType() {
    return AxiosInterceptor({
        url: '/dashboard/patient-type',
        method: 'get'
    })
}

// 대시보드 조회 타입별 방문자 건수
export function getDashboardVisitor(params) {
    return AxiosInterceptor({
        url: '/dashboard/visitor',
        method: 'get',
        params
    })
}

// 대시보드 학습 주차별 환자 건수 조회
export function getDashboardTrainingWeek() {
    return AxiosInterceptor({
        url: '/dashboard/training-week',
        method: 'get'
    })
}

